import * as Yup from "yup";

export const PHONE_NUMBER_REGEX = /^92\d{10}$/;
export const PHONE_NUMBER_FORMAT = "923XXXXXXXXX";
export const PHONE_NUMBER_MESSAGE = `Please enter a valid phone number in format ${PHONE_NUMBER_FORMAT}`;

export const normalizePhoneNumberValue = (value) => {
  const digits = String(value || "").replace(/\D/g, "");

  if (!digits) return "";
  if (digits.startsWith("92")) return digits.slice(0, 12);
  if (digits.startsWith("0")) return `92${digits.slice(1)}`.slice(0, 12);
  if (digits.length <= 10) return `92${digits}`.slice(0, 12);

  return digits.slice(0, 12);
};

export const buildPhoneNumberSchema = (requiredMessage) =>
  Yup.string()
    .trim()
    .matches(PHONE_NUMBER_REGEX, {
      message: PHONE_NUMBER_MESSAGE,
      excludeEmptyString: true,
    })
    .required(requiredMessage);

// Optional contacts (secondary driver, helper) can stay empty, but must still match
// the system format once they are filled in.
export const optionalPhoneNumberSchema = Yup.string()
  .trim()
  .matches(PHONE_NUMBER_REGEX, {
    message: PHONE_NUMBER_MESSAGE,
    excludeEmptyString: true,
  })
  .nullable();
